"use strict";

exports.__esModule = true;
exports.getArrowByPlacement = getArrowByPlacement;
var _ArrowIcon = require("./ArrowIcon");
exports.ArrowRightIcon = _ArrowIcon.ArrowRightIcon;
exports.ArrowLeftIcon = _ArrowIcon.ArrowLeftIcon;
exports.ArrowTopIcon = _ArrowIcon.ArrowTopIcon;
exports.ArrowBottomIcon = _ArrowIcon.ArrowBottomIcon;
function getArrowByPlacement(placement) {
  if (placement.indexOf('top') === 0) {
    return _ArrowIcon.ArrowTopIcon;
  }
  if (placement.indexOf('bottom') === 0) {
    return _ArrowIcon.ArrowBottomIcon;
  }
  if (placement.indexOf('left') === 0) {
    return _ArrowIcon.ArrowLeftIcon;
  }
  if (placement.indexOf('right') === 0) {
    return _ArrowIcon.ArrowRightIcon;
  }
  return undefined;
}
//# sourceMappingURL=Arrows.js.map